<div class="p-4">
  <h1 class="popup-title">
    <span class="error-icon" *ngIf="data$.messageTypeOptions && data$.messageTypeOptions.type === 'error'"
      >&#9888;</span
    >
    {{ data$.messageTitle | translate }}
  </h1>
  <div class="popup-intro" *ngIf="!varIsArray(data$.messageText)">
    {{ data$.messageText | translate }}
  </div>
  <div class="popup-intro" *ngIf="varIsArray(data$.messageText)">
    <!--    {{ data$.messageText | translate }}-->
    <div class="ul-padding">
      <ul class="list-decoration scrollable">
        <li *ngFor="let message of data$.messageText">
          {{ message.trim() }}
        </li>
      </ul>
    </div>
  </div>
</div>

<div class="">
  <form novalidate>
    <div class="divider"></div>

    <div class="cta wcf-button d-flex justify-content-end p-4">
      <button
        blocx-button
        *ngIf="data$.messageButtons.actionButton"
        (click)="onConfirm()"
        [variant]="'outline-primary'"
        type="button"
      >
        {{ data$.messageButtons.actionButton.buttonLabel | translate }}
      </button>
    </div>
  </form>
</div>
